import React, { useEffect, useState } from "react";
import Style from "./BaseLayout.module.scss";
import Navbar from "./Navbar";
import Home from "./home/Home";
import About from "./about/About";
import Portfolio from "./portfolio/Portfolio";
import CookieBanner from "./cookies/CookieBanner";
import PrivacyPolicy from "./privacy/PrivacyPolicy";
import NotFound from "./NotFound";
import ServicePage from "./services/ServicePage";
import { Link, Route, Routes } from "react-router-dom";
import { Box, Grid } from "@mui/material";
import { info } from "../info/Info";

export default function BaseLayout() {
  let [darkMode, setDarkMode] = useState(false);

  function handleToggleDarkMode() {
    let oppositeOfCurrentDarkMode = !darkMode;
    localStorage.setItem("darkMode", `${oppositeOfCurrentDarkMode}`);
    setDarkMode(oppositeOfCurrentDarkMode);
  }

  useEffect(() => {
    let detectedDarkMode = localStorage.getItem("darkMode") === "true";

    if (detectedDarkMode) {
      setDarkMode(detectedDarkMode);
    } else {
      localStorage.setItem("darkMode", "false");
    }
  }, []);

  return (
    <Box className={darkMode ? Style.dark : Style.light}>
      <Grid
        container
        display={"flex"}
        flexDirection={"column"}
        minHeight={"100vh"}
        justifyContent={"space-between"}
      >
        <Grid item>
          <Navbar darkMode={darkMode} handleClick={handleToggleDarkMode} />
        </Grid>
        <Grid item flexGrow={1}>
          <Routes>
            <Route exact path={"/"} element={<Home />} />
            <Route exact path={"/about"} element={<About />} />
            <Route exact path={"/portfolio"} element={<Portfolio />} />
            <Route path={info.services.trafego.path} element={<ServicePage service={info.services.trafego} />} />
            <Route path={info.services.programador.path} element={<ServicePage service={info.services.programador} />} />
            <Route path={"*"} element={<NotFound />} />
          </Routes>
        </Grid>
        <Grid item>
          <Box
            component={"footer"}
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            py={"1.5rem"}
            sx={{ opacity: 0.7 }}
            width={"100%"}
          >
            <p>
              Made by <a href={"https://github.com/marck0101"}>marck0101</a>
              {" · "}
              <a href={info.blogUrl}>Blog do {info.fullName}</a>
            </p>
            <p>
              <Link to={info.services.trafego.path}>Gestor de tráfego</Link>
              {" · "}
              <Link to={info.services.programador.path}>Programador full stack</Link>
            </p>
            <p>&copy; {new Date().getFullYear()}</p>
          </Box>
        </Grid>
      </Grid>
      <CookieBanner />
      <PrivacyPolicy />
    </Box>
  );
}
